import { denormalize, normalize } from 'normalizr'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import api from '../../api'
import createSlice from '../create-slice'
import { practiceFormOptionsSchema } from '../normalizr'
import { getEntities } from './entities'

const practiceFormOptionsInitialState = {
  practiceFormOptionsIds: {},
  pagination: {},
}

const practiceFormOptionsSlice = createSlice({
  name: 'practiceFormOptions',
  initialState: practiceFormOptionsInitialState,
  reducers: {
    setPracticeFormOptions: (
      state,
      { payload: { result, id, pagination } },
    ) => {
      state.practiceFormOptionsIds[id] = result
      state.pagination = pagination
    },
  },
})

const { actions } = practiceFormOptionsSlice

const selectState = state => state[practiceFormOptionsSlice.name]

export function usePracticeFormOption(id) {
  const { practiceFormOptionsIds } = useSelector(selectState)
  const entities = useSelector(getEntities)
  const practiceFormOptions = denormalize(
    practiceFormOptionsIds[id] || [],
    [practiceFormOptionsSchema],
    entities,
  )
  return practiceFormOptions
}

export function fetchPracticeFormOptions(id, page = 1, perPage = 10) {
  return async dispatch => {
    const { data, meta } = await api.practiceFormOptions.getPracticeFormOptions(
      page,
      perPage,
      id,
    )
    dispatch(
      actions.setPracticeFormOptions({
        ...normalize(data, [practiceFormOptionsSchema]),
        id,
        pagination: meta,
      }),
    )
  }
}

export function useFetchPracticeFormOption(id, page, perPage) {
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(fetchPracticeFormOptions(id, page, perPage))
  }, [dispatch, id, page, perPage])
}

export function addPracticeFormOption(data) {
  return api.practiceFormOptions.addPracticeFormOption(data)
}

export function deletePracticeFormOption(dataId) {
  return api.practiceFormOptions.deletePracticeFormOption(dataId)
}

export function updatePracticeFormOption(dataId, updatedData) {
  return api.practiceFormOptions.updatePracticeFormOption(dataId, updatedData)
}

export function usePracticeFormOptionPagination() {
  const { pagination } = useSelector(selectState)
  return pagination
}

export default practiceFormOptionsSlice
